import { createFileRoute } from "@tanstack/react-router";
import { WelcomePage } from "../../../pages/welcome-page/welcome-page";

export const Route = createFileRoute("/_auth/_frame/welcome")({
  component: WelcomePage,
});
